module.exports = __webpack_public_path__ + "img/bell-icon.66669d5c.svg";